// extracted by mini-css-extract-plugin
export default {"fullscreen":"styles_fullscreen__u0ORI","lds-ring":"styles_lds-ring__D9GQE"};